import type { FaireProductEntity } from "../../entity_types/product";

export const p_4k4tckidis: FaireProductEntity = {
  token: "p_4k4tckidis",
  type: "product",
  name: "Milk and Bread Market Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/33dfa3bec96594d231cb4aa49a8cdc21cfb94ae819d6ab80278a9229d16b2b5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3a98c969df0d4282214d7931ce3ac832e19d601c215bb268e4a9d0664283cac1/1558642419.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4149815abfa5799669cc1925d56a55fd7d5859c4e1335a7dede96490c7467ac9/1558642428.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:32.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
